module.exports = __webpack_public_path__ + "static/media/cloud_icon.b9f711c2.svg";